module.exports = __webpack_public_path__ + "b79e65f66d2268c426af665488abd61c.png";